module.exports = __webpack_public_path__ + "img/enter_name_NO.a60e4c0c.svg";